import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar.jsx';
import Footer from './components/Footer.jsx';
import Home from './pages/Home.jsx';
import About from './pages/About.jsx';
import Programs from './pages/Programs.jsx';
import EducateHer from './pages/EducateHer.jsx';
import RTYGIA from './pages/RTYGIA.jsx';
import AikpokpodionFellowship from './pages/AikpokpodionFellowship.jsx';
import Resources from './pages/Resources.jsx';
import Contact from './pages/Contact.jsx';
import Updates from './pages/Updates.jsx';
import './styles/main.css';
import './styles/animations.css';
import './styles/pages.css';
import Announcement from './pages/announcements/1.jsx';

function App() {
    return (
        <Router>
            <div className="app-wrapper">
                <Navbar />
                <main className="main-content">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/programs" element={<Programs />} />
                        <Route path="/programs/educateher" element={<EducateHer />} />
                        <Route path="/programs/rtygia" element={<RTYGIA />} />
                        <Route path="/programs/aikpokpodion-fellowship" element={<AikpokpodionFellowship />} />
                        <Route path="/resources" element={<Resources />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/updates" element={<Updates />} />
                        <Route path="/announcements/:id" element={<Announcement />} />
                    </Routes>
                </main>
                <Footer />
            </div>
        </Router>
    );
}

export default App;
